import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import union from 'lodash/union';

import {
  ADD_ROTATING_SEGMENT_ID,
  DELETE_ROTATING_SEGMENT_ID,
} from 'actions/rotatingSegmentTitles';

const INITIAL_STATE = Immutable({ rotatingSegmentIds: [] });

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case ADD_ROTATING_SEGMENT_ID:
      return state.merge({
        rotatingSegmentIds: union(
          [action.payload.id],
          state.rotatingSegmentIds,
        ),
      });
    case DELETE_ROTATING_SEGMENT_ID:
      return state.merge({
        rotatingSegmentIds: state.rotatingSegmentIds.filter(
          id => id !== action.payload.id,
        ),
      });
    default:
      return state;
  }
};
